<template>
  <sonicu-button
    bg-color="bg-orange-600"
    @click="changeSpeed"
  >
    <span v-if="ajaxPollingData">
      <loading></loading>
    </span>
    <span v-else>
      Check-in Frequency (last 60 seconds)
    </span>
  </sonicu-button>
  <ul>
    <template v-for="(checkins, meterSerial) in meters">
      <li :class="(checkins > 3) ? 'bg-green-200' : 'bg-red-200'">
        {{ meterSerial }}: {{ checkins }}
      </li>
    </template>
  </ul>

</template>

<script>
import SonicuButton from "@/components/elements/buttons/SonicuButton";
import Loading from "@/components/elements/loading";
import {get} from "axios";
export default {
  name: "ProbeCalibrationReadFrequencyCheck",
  components: {Loading, SonicuButton},
  props:{
    companyId:{
      type: String,
      required: true
    },
    zoneId:{
      type: String,
      required: true
    },
  },
  data(){
    return {
      ajaxPollingData: false,
      meters: {},
    };
  },
  computed: {
    href(){
      return '/api-internal/' + this.companyId + '/probe-calibration/read-frequency-check/' + this.zoneId;
    },
  },
  methods: {
    changeSpeed(){
      this.ajaxPollingData = true;
      get(this.href)
        .then((response) => {
          this.ajaxPollingData = false;
          this.meters = response.data.data;
        })
        .catch((error) => {
          this.ajaxPollingData = false;
        });
    }
  }
}
</script>

<style scoped>

</style>